// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__kKRXS","spinnerWrapper":"Spinner_spinnerWrapper__GIPOK","spinner":"Spinner_spinner__nuIEw","spin":"Spinner_spin__UWfPX"};